var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('current-month-users',{key:_vm.appUUID,attrs:{"app-uuid":_vm.appUUID},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var usersCount = ref.usersCount;
return _c('base-analytics-banner',{attrs:{"with-top-border":"","with-orange-border":""}},[_c('base-analytics-banner-content',{attrs:{"slot":"header","label":_vm.label,"content":usersCount.count,"heading":""},slot:"header"})],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }